export interface EquipmentCancelConf {
	ccfg_id?: number;
	ccfg_start?: number;
	ccfg_end?: number;
	ccfg_unit?: "HOUR" | "WORK" | "DAY";
	ccfg_raito?: number;
	delete_flug?: boolean;
}

export const ObjectToEquipmentCancelConf = (obj: any): EquipmentCancelConf => {
	return {
		ccfg_id: typeof obj.ccfg_id == "string" ? parseInt(obj.ccfg_id) : obj.ccfg_id,
		ccfg_start: typeof obj.ccfg_start == "string" ? parseInt(obj.ccfg_start) : obj.ccfg_start,
		ccfg_end: typeof obj.ccfg_end == "string" ? parseInt(obj.ccfg_end) : obj.ccfg_end,
		ccfg_unit: typeof obj.ccfg_unit == "string" && obj.ccfg_unit.includes("HOUR", "WORK", "DAY") ? obj.ccfg_unit : undefined,
		ccfg_raito: typeof obj.ccfg_raito == "string" ? parseInt(obj.ccfg_raito) : obj.ccfg_raito,
		delete_flug: typeof obj.delete_flug == "string" ? (obj.delete_flug == "1" ? true : false) : undefined,
	};
};
